import React, {useCallback} from 'react'
import {
  Alerts,
  reportsSummaryDownload,
  RPCDocs,
  useRPCContext,
} from '@therms/react-modules'
import {
  Button,
  ContextMenu,
  Dropdown,
  Icon,
  toastManager,
} from '@therms/atalaya'
import {IoMdDownload} from 'react-icons/io'
import {MdDataset, MdRefresh} from 'react-icons/md'

interface BulkDownloadReportsDropdownProps {
  args: RPCDocs.Reports.GetReportsList.v1.Args
}

function BulkDownloadReportsContextMenu({
  args,
}: BulkDownloadReportsDropdownProps) {
  const {rpcService} = useRPCContext()

  const handleDownload = useCallback(
    (config: {fileName?: string; format: 'csv' | 'excel'}) => {
      const toastId = Alerts.info(
        <div>
          <Icon Icon={MdRefresh} spin /> Downloading file, please wait...
        </div>,
        {autoClose: false, position: 'top-center'},
      )

      rpcService.Reports.GetReportsList.v1
        .call(
          {...args, pagination: {limit: 5000}},
          {
            timeout: 60_000,
          },
        )
        .then((response) => {
          if (!response.data.reports) return

          reportsSummaryDownload(response.data.reports, null, {
            fileName:
              config.fileName || `Reports Summary ${new Date().toISOString()}`,
            format: config.format,
          })
        })
        .catch((err: any) => {
          Alerts.error('There was a problem during download, please try again.')
          console.error('err downloading reports', err)
        })
        .finally(() => toastManager.dismiss(toastId))
    },
    [args],
  )

  return (
    <Dropdown
      controller={({close, isOpen, open}) => (
        <Button onClick={isOpen ? close : open} subtle>
          <Icon Icon={IoMdDownload} />
        </Button>
      )}
    >
      <ContextMenu.Option onClick={() => handleDownload({format: 'csv'})}>
        <Icon Icon={MdDataset} /> <span>Download CSV</span>
      </ContextMenu.Option>

      <ContextMenu.Option onClick={() => handleDownload({format: 'excel'})}>
        <Icon Icon={MdDataset} /> <span>Download Excel</span>
      </ContextMenu.Option>
    </Dropdown>
  )
}

export {BulkDownloadReportsContextMenu}
